





import { Vue, Component } from 'vue-property-decorator';
import appConfig from '../../appConfig';

@Component
export default class TemsOfServiceConfirm extends Vue {
    get tosUrl(): string {
        return appConfig.tosPageUrl;
    }
}
